



































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import VueSignaturePad from 'vue-signature-pad'
import CadastroMedicoStore from '@/components/CadastroMedico/store/CadastroMedicoStore'
import EventBus from '@/plugins/EventBus'
import { timeoutDefault } from '@/utils/common'
import _ from 'lodash'

Vue.use(VueSignaturePad)

@Component
export default class ComponentAssinaturaMobile extends Vue {
  $refs!: {
    signaturePad: any,
  }

  model: boolean = false
  penColor: string = 'rgb(51, 0, 133)'
  loadConfirmar: boolean = false

  get getCadastroMedicoStore() {
    return getModule(CadastroMedicoStore, this.$store)
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  async save() {
    this.loadingConfirmar = true
    const { isEmpty, data } = this.$refs.signaturePad.saveSignature()

    if (!isEmpty) {
      const image = data.toString().replace('data:image/png;base64,', '')
      this.getCadastroMedicoStore.setAssinatura(image)
      this.getCadastroMedicoStore.cadastroMedicoMessage.assinatura = ''
      await timeoutDefault()
      this.model = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Nenhuma assinatura foi feita.', icon: 'warning', color: '#C62828' })
    }

    this.loadingConfirmar = false
  }

  async undo() {
    this.$refs.signaturePad.undoSignature()
  }
}
